import React from "react";
import {
	Link
} from "react-router-dom";
import config from './../config.js';
import Loading from './../../components/loading.js';

import Aside from './common/aside.js';
import Projectgroup from './project_service_group.js';
import Serviceparams from './project_service_params.js';
import {
	getparams
} from './common/params.js';
import Notification from 'rc-notification';

let notification = null;
Notification.newInstance({
	style: {
		top: '45px',
		right: 0
	}
}, (n) => notification = n);

export default class ProjectImageCreate extends React.Component {
	constructor(props) {
		super(props);
		//console.log(props);
		const {
			projectid,
			type
		} = props.match.params;
		let user = {};
		if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
			user = JSON.parse(localStorage.user);
		}

		const pagetitle = '项目管理 ';
		this.state = {
			user: user,
			loading: false,
			projectid: projectid,
			type: type, //vbm or tbss
			project: '',
			creator: '',
			page_title: pagetitle,
			page_subtitle: '创建' + type.toUpperCase() + '任务',
			step: '1',
			taskname: '',
			isrequest: true,
			groups: [],
			ncdata: [],
			ptdata: []
		}
		document.title = pagetitle + '创建' + type.toUpperCase() + '任务';
		this.shiftstep = this.shiftstep.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.setTaskName = this.setTaskName.bind(this);
	}


	componentDidMount() {
		const type = this.state.type;
		const imageparams = JSON.stringify(getparams(type));
		//console.log(type)
		this.setState({
			params: JSON.parse(imageparams)
		});
		this.onInitial(type);
		this.getProject();
	}


	componentWillReceiveProps(nextProps) {
		const {
			type
		} = nextProps.match.params;
		const imageparams = JSON.stringify(getparams(type));
		this.setState({
			page_subtitle: '创建' + type.toUpperCase() + '任务',
			type: type,
			step: '1',
			params: JSON.parse(imageparams),
			isrequest: true
		});
		document.title = this.state.page_title + '创建' + type.toUpperCase() + '任务';
		this.onInitial(type);
	}



	goback() {
		this.props.history.goBack(1);
	}

	notify(message) {
		notification.notice({
			content: <span>{message}</span>,
			duration: 4,
			style: {
				'bottom': 0,
				'right': 0
			}
		});
	}


	getProject() {
		const me = this;

		let {
			projectid,
			user
		} = me.state;
		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			Authorization: localStorage.token,
			request: 'project'
		};
		fetch(config.host + '/project/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					const data = json.data;
					me.setState({
						project: data.project,
						creator: data.creator
					});
				} else {
					me.notify(json.message);
				}
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	shiftstep(event) {
		const me = this;
		const target = event.target;
		const id = target.id;
		if (!/^\d+$/.test(id)) return;
		me.setState({
			step: id
		});
	}


	activeClass(id) {
		return id === this.state.step ? 'btn btn-sm btn-danger mr-2' : 'btn btn-sm btn-outline-secondary mr-2';
	}


	onInitial(type) {
		const me = this;
		if (me.state.isrequest === false) return;
		const postdata = {
			userid: me.state.user.id,
			projectid: me.state.projectid,
			service_type: type,
			Authorization: localStorage.token,
			request: 'groupservicelist'
		};
		me.setState({
			loading: true
		});
		fetch(config.host + '/project_group/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				//console.log(json.data[0].subjects.data[0].head[0].files);
				if (json.status === 1) {
					let groups = json.data;
					groups.map(function(g, i) {
						g.checked = false;
						g.checkedsubject = 0;
						g.showsubjects = true;
						if (g.subjects.size > 0) {
							g.subjects.data.map((item, i) => {
								item.showfiles = false;
								item.checked = false;
								if (typeof(item.task) !== 'undefined' && item.task.length) {
									item.task.map((t, n) => {
										if (t.files.length) {
											t.files.map((f, m) => {
												f.checked = false;
												return f;
											})
										}
										return t;
									});
								}
								if (typeof(item.head) !== 'undefined' && item.head.length) {
									item.head.map((t, n) => {
										if (t.files.length) {
											t.files.map((f, m) => {
												f.checked = false;
												return f;
											})
										}
										return t;
									});
								}
								return item;
							});
						}
						return g;
					});

					let groupsdata = JSON.stringify(groups);
					me.setState({
						ncdata: JSON.parse(groupsdata),
						ptdata: JSON.parse(groupsdata)
					});
				}
				me.setState({
					loading: false
				});
			})
			.catch(function(error) {
				console.log(error);
				me.setState({
					loading: false
				});
			});
	}


	handleGroupSelect(groups) {
		//console.log(groups)
		let data = [];
		groups.map(function(g, i) {
			if (g.subjects.size) {
				g.subjects.data.map((item, i) => {
					if (item.checked) {
						if (typeof(item.head) !== 'undefined' && item.head.length) {
							item.head.map((t, n) => {
								if (t.files.length) {
									t.files.map((f, m) => {
										if (f.checked) {
											data.push(f.id);
										}
										return f;
									})
								}
								return t;
							});
						}
					}
					return item;
				});
			}
			return g;
		});
		//console.log(data)
		return data;
	}


	handleParamSelect(params) {
		let data = [];
		params.map((p, i) => {
			if (p.content.type === 'list') {
				p.content.child.map((c, n) => {
					if (c.type === 'radio' && c.defaultCheck) {
						data.push({
							[c.name]: c.value
						});
					}
					if (c.type === 'number' || c.type === 'text') {
						data.push({
							[c.name]: c.value
						});
					}
					return c;
				});
			}
			if (p.content.type === 'tabs') {
				p.content.child.map((c, n) => {
					if (c.defaultCheck) {
						data.push({
							[c.name]: c.value
						});
						c.tabcontent.map((tab, j) => {
							if (typeof(tab.name) !== 'undefined' && tab.type === 'number') {
								data.push({
									[tab.name]: tab.value
								});
							}
							if (typeof(tab.input) !== 'undefined') {
								tab.input.map((input, i) => {
									if (input.defaultCheck) {
										data.push({
											[input.name]: input.value
										});
									}
									return input;
								});
							}
							return tab;
						})
					}
					return c;
				});
			}
			return p;
		});

		return data;
	}


	handleSubmit(event) {
		event.preventDefault();
		event.stopPropagation();
		const me = this;
		const {
			ncdata,
			ptdata,
			params,
			taskname
		} = me.state;
		const nc = me.handleGroupSelect(ncdata);
		const pt = me.handleGroupSelect(ptdata);
		const pm = me.handleParamSelect(params);
		console.log(nc);
		console.log(pt);
		console.log(pm);
		if (!nc.length) {
			me.setState({
				step: '1'
			});
			me.notify('请选择对照组数据');
			return;
		}
		if (!pt.length) {
			me.setState({
				step: '2'
			});
			me.notify('请选择病人组数据');
			return;
		}

		if (taskname === '') {
			me.setState({
				step: '4'
			});
			me.notify('请设置任务名称');
			return;
		}
		me.submit_task(nc, pt, pm);
	}


	submit_task(nc, pt, pm) {
		const me = this;
		const {
			projectid,
			user,
			type,
			taskname,
			creator
		} = me.state;
		let postdata = {
			request: 'create',
			type: type,
			userid: user.id,
			createid: creator.id,
			companyid: user.company_id,
			Authorization: localStorage.token,
			projectid: projectid,
			nc: nc,
			pt: pt,
			taskname: taskname
		};
		console.log(postdata)
		let params = {};
		pm.map((p, i) => {
			params = Object.assign(params, p);
			return p;
		});
		postdata = Object.assign(postdata, params);
		//console.log(postdata)
		me.setState({
			loading: true
		});
		fetch(config.host + '/project_service/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				//console.log(json)
				if (json.status === 1) {
					setTimeout(() => {
						me.props.history.push('/console/myprojects/project/service_list/' + projectid + '/' + type);
					}, 1500);

				}
				me.setState({
					loading: false
				});
				me.notify(json.message);
			})
			.catch(function(error) {
				me.setState({
					loading: false
				});
			});
	}


	setTaskName(event) {
		const target = event.target;
		this.setState({
			taskname: target.value
		})
	}


	render() {
		const me = this;
		const {
			step,
			projectid,
			type,
			ncdata,
			ptdata,
			params
		} = me.state;

		return (
			<div className="row">
				<Loading display={me.state.loading} />
        		<div className="col-10 pb-3">
					<nav className="animated fadeInUp">
						<ol className="breadcrumb px-0">
							<li className="breadcrumb-item">
                  				<a onClick={()=>this.goback()} ><strong><i className="fa fa-chevron-left"></i> 返回</strong></a>
                			</li>
							<li className="breadcrumb-item "><Link className="text-dark " to={`/console/myprojects/project/${projectid}/MR`}><strong>{me.state.project.name}</strong></Link>
						</li>
						<li className="breadcrumb-item active">
							创建者: {me.state.creator.realname || me.state.creator.email || me.state.creator.title || me.state.creator.address || me.state.creator.office}
						</li>
						<li className="breadcrumb-item " aria-current="page"><strong>{me.state.page_subtitle}</strong></li>
					</ol>
				</nav>

				<div className="animated fadeInDown">
					<button className={me.activeClass('1')} onClick={me.shiftstep} id="1">1. 选择对照组</button>
					<button className={me.activeClass('2')} onClick={me.shiftstep} id="2">2. 选择病人组</button>
					<button className={me.activeClass('3')} onClick={me.shiftstep} id="3">3. 设置参数</button>
					<button className={me.activeClass('4')} onClick={me.shiftstep} id="4">4. 完成</button>
				</div>

				<form onSubmit={this.handleSubmit}>
					{(() => {
						switch(step){
							case '1':
							return( <div className=" fadeIn animated"><Projectgroup project={{step:step,groups:ncdata,type:type}}  /></div> )
							break;
							case '2':
							return( <div className=" fadeIn animated"><Projectgroup project={{step:step,groups:ptdata,type:type}}  /></div> )
							break;
							case '3':
							return( <div className=" fadeIn animated"><Serviceparams project={{params:params}}  /></div> )
							break;
							case '4':
							return(<div className="row  my-3 py-3">
											<div className="col">
											<div className="input-group">
											  <div className="input-group-prepend">
											    <span className="input-group-text">任务名称</span>
											  </div>
											  <input type="text" className="form-control" name="taskname" value={this.state.taskname} onChange={this.setTaskName} />
											</div>
											</div>
											<div className=" col">
												<button className="btn btn-primary" type="submit" title="Submit"><i className="fa fa-send"></i> 提交{this.state.type.toUpperCase()}任务</button>
											</div>
								</div>)
							break;
							default:
							break;
						}
					})()}

				</form>

			</div>
			<div className="col-2  pl-0 pr-0">
				<Aside data={me.props.match.params} />
			</div>
		</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/console/project_image_create.js